import PreferredNetworkAndOTASPService from '../../services/preferred-network-and-otasp';
import { enqueueSnackbarAction } from '../snackbar/actions';
import { AppState, AppThunkDispatch } from '..';
import { getCommandsByDeviceKey } from '../commands/actions';
import { PreferredNetworkAndOTASPActionNames } from './types';

export const preferredNetworkAndOTASPAction =
  (input: any, deviceKey: string) =>
  async (dispatch: AppThunkDispatch, getState: () => AppState) => {
    const {
      login: { client, envVariables },
    } = getState();
    const preferredNetworkAndOTASPService = new PreferredNetworkAndOTASPService(
      client,
      envVariables.preferredNetworkAndOTASPV1,
    );
    try {
      const response = await preferredNetworkAndOTASPService.preferredNetworkCommandQueue(input);
      if (response.data) {
        dispatch(
          enqueueSnackbarAction({
            message: 'Command Queued Successfully',
            options: { variant: 'success' },
          }),
        );
        if (input.configs.cellRadioCommand === 'ACTIVATE_OTASP') {
          dispatch({
            type: PreferredNetworkAndOTASPActionNames.ACTIVATE_OTASP,
            payload: response.data,
          });
        } else {
          dispatch({
            type: PreferredNetworkAndOTASPActionNames.SET_PREFERRED_NETWORK_STATUS,
            payload: response.data,
          });
        }

        dispatch(getCommandsByDeviceKey({ deviceKey, statuses: '1' }, true));
      }
    } catch (error) {
      dispatch(
        enqueueSnackbarAction({
          message: 'Command queue updating slower than expected',
          options: { variant: 'warning' },
        }),
      );
    }
  };
